/**
 * Validates a Calendly URL format
 * Supports:
 * - https://calendly.com/username
 * - https://calendly.com/username/event-type
 * - https://username.calendly.com
 * - Custom domains (any https URL)
 */
export function validateCalendlyUrl(url: string): { valid: boolean; error?: string } {
  if (!url || url.trim() === '') {
    return { valid: false, error: 'Calendly URL is required' }
  }

  // Must start with https://
  if (!url.startsWith('https://')) {
    return { valid: false, error: 'Calendly URL must start with https://' }
  }

  // Try to parse as URL
  try {
    const parsedUrl = new URL(url)

    // Check if it's a calendly.com URL
    if (parsedUrl.hostname === 'calendly.com' || parsedUrl.hostname.endsWith('.calendly.com')) {
      // Must have a path (username or subdomain)
      if (parsedUrl.pathname === '/' && parsedUrl.hostname === 'calendly.com') {
        return { valid: false, error: 'Please include your Calendly username (e.g., https://calendly.com/yourname)' }
      }
      return { valid: true }
    }

    // Accept any other https URL (custom domains)
    return { valid: true }
  } catch (e) {
    return { valid: false, error: 'Invalid URL format' }
  }
}

/**
 * Example valid URLs:
 * - https://calendly.com/john-doe
 * - https://calendly.com/john-doe/30min
 * - https://johndoe.calendly.com
 * - https://book.johndoe.com
 */
